module.exports = __webpack_public_path__ + "static/img/Gtu2@2x.e32e4bc8.png";